// @flow
import React from 'react';
import USBModal, { ModalHeader, ModalBody, ModalFooter } from '@usb-shield/react-modal';
import {
    USBButtonGroup, USBButton
} from '@usb-shield/components-react/dist/cjs';


type ConfirmationDialogProps = {
    open: boolean,
    title: String,
    toggle: () => void,
    body: String,
    multiLineBody : Array,
    primaryButtonText: String,
    primaryClickHandler: () => void
}
const ConfirmationDialog = (props) => {
    const fulldetails = props.multiLineBody ? props.multiLineBody.map((item,index)=>{
    let temp = item.split(":")
    return <div key={index + '' + item}><span style={{fontWeight:'bolder'}}>{temp[0]} : </span><span>{temp[1]}</span></div>}) : '';
    return (
        <USBModal
            id='confirmation-dialog'
            isOpen={props.open}
            handleClose={props.toggle}
        >
            <ModalHeader id='confirmation-dialog-header'>
                {props.title}
            </ModalHeader>

            <ModalBody>
            
                <div>{props.body}</div>
                <br></br>
                { props?.multiLineBody?.length > 0 ? <div>{fulldetails}</div> : '' }
                
            </ModalBody>
            <ModalFooter>
                <USBButtonGroup>
                    <USBButton
                        variant='secondary'
                        // handleClick={props.cancelHandler}
                        handleClick = {props.toggle}
                        ariaLabel='close modal'
                    >
                        Cancel
                    </USBButton>
                    <USBButton
                        variant='primary'
                        handleClick={props.primaryClickHandler}
                        ariaLabel={props.primaryButtonText}
                    >
                        {props.primaryButtonText}
                    </USBButton>
                </USBButtonGroup>
            </ModalFooter>
        </USBModal>
    )
}

export default ConfirmationDialog;